"use strict";
import { FeatureFlags, getFeatureFlagName } from "features/gating/flags";
import { getStatsigClient } from "features/gating/sdk/statsig";
export function isInstantTokenBalanceUpdateEnabled() {
  return getStatsigClient().checkGate(getFeatureFlagName(FeatureFlags.InstantTokenBalanceUpdate));
}
